import actionType from '../actions/actionTypes';

export interface ITenantReducer {
    isRequesting: boolean;
}

const initialState: ITenantReducer = {
    isRequesting: false
};

export default function (
    state: ITenantReducer = initialState,
    action
): ITenantReducer {
    switch (action.type) {
        case actionType.TENANT_REQUEST:
            return {
                ...state,
                isRequesting: true
            };

        case actionType.TENANT_ACCEPT:
            return {
                ...state,
                isRequesting: false
            };

        case actionType.CLEAR_STATE:
            return {
                ...initialState
            };

        default:
            return state;
    }
}
